import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getOrganizerById } from "api/company.api";
import { getImageUrl } from "utils/imageHelper";
import ImageViewer from "components/common/ImageViewer";


export default function ViewOrganizer() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [company, setOrganizer] = useState(null);
  const [loading, setLoading] = useState(true);

  const [viewerOpen, setViewerOpen] = useState(false); 
  

  useEffect(() => {
    fetchOrganizer();
  }, []);

  const fetchOrganizer = async () => {
    try {
      const res = await getOrganizerById(id);
      setOrganizer(res.data.data);
    } catch (error) {
      console.error("Failed to load company", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p className="p-6">Loading...</p>;
  }

  if (!company) {
    return <p className="p-6 text-red-500">Organizer not found</p>;
  }

  return (
    <div className="p-6 space-y-8">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Organizer Details</h1>
        <button
          onClick={() => navigate(-1)}
          className="rounded-xl border px-4 py-2"
        >
          Back
        </button>
      </div>

      <Card title="Organizer Information">
        <Info label="Name" value={company.companyName} />
        <Info label="Email" value={company.companyEmail} />
        <Info
          label="Mobile"
          value={`${company.companyMobileCountryCode} ${company.companyMobile}`}
        />
        <Info label="Phone" value={company.companyPhoneNumber} />
        <Info label="Website" value={company.companyWebsite} />
        <Info label="GST" value={company.companyGST} />
        <Info label="Address" value={company.companyAddress} />
        <Info label="City" value={company.companyCity} />
        <Info label="District" value={company.companyDistrict} />
        <Info label="State" value={company.companyState} />
        <Info label="Country" value={company.companyCountry} />
        <Info label="Pincode" value={company.companyPincode} />

        {company.companyLogo && (
          <div className="col-span-2">
            <p className="text-sm text-gray-500 mb-1">Organizer Logo</p>
            <>
            <img
              src={getImageUrl(company.companyLogo)}
              alt="Organizer Logo"
              className="h-24 rounded-xl border"
               onClick={() => setViewerOpen(true)} 
            />
            <ImageViewer
                          open={viewerOpen}
                          onClose={() => setViewerOpen(false)}
                          src={getImageUrl(company.companyLogo)}
                        />
                        </>
          </div>
        )}
      </Card>

      <Card title="Admin Information">
        <Info label="Admin Name" value={company.adminName} />
        <Info label="Admin Email" value={company.adminEmail} />
        <Info
          label="Admin Mobile"
          value={`${company.adminMobileCountryCode} ${company.adminMobile}`}
        />
        <Info
          label="Admin Password"
          value={company.adminPassword}
        />
      </Card>

      <Card title="Project Modules">
        {company.projectModules?.length ? (
          <div className="flex flex-wrap gap-2">
            {company.projectModules.map((m) => (
              <span
                key={m}
                className="rounded-full bg-brand-100 px-4 py-1 text-sm"
              >
                {m}
              </span>
            ))}
          </div>
        ) : (
          <p className="text-gray-500">No modules assigned</p>
        )}
      </Card>
    </div>
  );
}

function Card({ title, children }) {  
  return (
    <div className="rounded-[20px] bg-white p-6 shadow-3xl">
      <h3 className="mb-4 text-lg font-semibold">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {children}
      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <p className="text-sm text-gray-500">{label}</p>
      <p className="font-medium">{value || "-"}</p>
    </div>
  );
}
